const interactiveListRowSelector = [
  "a",
  "button",
  "input",
  "select",
  "textarea",
  "[role='button']",
  "[role='menuitem']",
].join(",");

type ClosestEventTarget = EventTarget & {
  closest?: (selector: string) => Element | null;
};

export function isInteractiveListRowTarget(target: EventTarget | null) {
  const closest = (target as ClosestEventTarget | null)?.closest;

  return typeof closest === "function"
    && Boolean(closest.call(target, interactiveListRowSelector));
}
